exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".about-container{padding-bottom:10px}@media(max-width: 575px){.about-container{padding:0 22px 10px 22px}}.about-container .policy-about-title{margin-bottom:20px;font-size:1.875rem;font-weight:500;text-align:center}@media(max-width: 575px){.about-container .policy-about-title{margin-top:21px;font-size:1.5rem;line-height:24px}}.about-container p{font-size:1rem;line-height:19px}.about-container p span{font-weight:500}.about-container ul{margin-bottom:20px}.about-container ul li{font-size:1rem;font-weight:300}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PolicyReview/About/About.scss
// module id = 8056
// module chunks = 13